import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Zoom from 'react-reveal/Zoom';
import All from "../../../../src/docs/assets/profiles/all.jpg";
import Allred from "../../../../src/docs/assets/profiles/allred.jpg";
import Anthony from "../../../../src/docs/assets/profiles/anthony.jpg";
import Borba from "../../../../src/docs/assets/profiles/borba.jpg";
import Branca from "../../../../src/docs/assets/profiles/branca.jpg";
import Brings from "../../../../src/docs/assets/profiles/brings.jpg";
import Brown from "../../../../src/docs/assets/profiles/brown.jpg";
import Carter from "../../../../src/docs/assets/profiles/carter.jpg";
import Jepsen from "../../../../src/docs/assets/profiles/jepsen.jpg";
import Joseph from "../../../../src/docs/assets/profiles/joseph.jpg";
import Livas from "../../../../src/docs/assets/profiles/livas.jpg";
import Rahimi from "../../../../src/docs/assets/profiles/rahimi.jpg";
import Shippobotham from "../../../../src/docs/assets/profiles/shippobotham.jpg";
import Tudor from "../../../../src/docs/assets/profiles/tudor.jpg";
import Wright from "../../../../src/docs/assets/profiles/wright.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Zoom,
  All,
  Allred,
  Anthony,
  Borba,
  Branca,
  Brings,
  Brown,
  Carter,
  Jepsen,
  Joseph,
  Livas,
  Rahimi,
  Shippobotham,
  Tudor,
  Wright,
  React
};